import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export const ConfirmLimitDialog = ({ pending, onCancel, onConfirm }) => {
  const n = pending?.to_delete || 0;
  const who = pending ? [pending.user.name, pending.user.email && `(${pending.user.email})`].filter(Boolean).join(" ") : "";
  const plural = n === 1 ? "project" : "projects";
  return (
    <AlertDialog open={Boolean(pending)} onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent data-testid="confirm-limit-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle data-testid="confirm-limit-title">{n} {plural} will be deleted</AlertDialogTitle>
          <AlertDialogDescription>
            {who} has {pending?.user.project_count} projects. Lowering their limit to {pending?.limit} permanently deletes the {n} {plural} they created and haven't edited for the longest. This can't be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <ul className="max-h-48 space-y-1 overflow-y-auto rounded-xl border bg-muted/40 p-3 text-sm" data-testid="confirm-limit-projects">
          {(pending?.projects || []).map((name, i) => <li key={`${name}-${i}`} className="truncate">• {name}</li>)}
        </ul>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-limit-cancel">Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-destructive text-destructive-foreground hover:bg-destructive/90" data-testid="confirm-limit-button">
            Delete {n} {plural} and set limit
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
